// Immutable master brand asset — do not redraw, restyle or substitute.
const MASTER = "/brand/buildease-master-logo.png";
const ICON = "/brand/buildease-icon.png";

export const LogoMark = ({ className = "h-6 w-6" }) => (
    <img
        src={ICON}
        alt="BuildEase mark"
        className={`${className} object-contain`}
    />
);

export const Logo = ({ className = "h-[54px] w-auto md:h-[64px]" }) => (
    <img
        src={MASTER}
        alt="BuildEase — Simplify. Build. Live."
        className={`${className} object-contain`}
    />
);
